module.exports = __webpack_public_path__ + "img/转圈.7e557466.png";